module.exports = __webpack_public_path__ + "img/course_review3.4afac2f3.png";